import  {useState , useEffect} from "react";
import { Box, Typography, Avatar } from "@mui/material";
import "./Testimonials.scss";


const testimonials = [
  {
    quote: "Tron saved me ₹5000 in OPD expenses in just 3 months!",
    name: "Riya Singh",
    location: "Delhi",
  },
  {
    quote: "Finally, an affordable healthcare plan that actually covers my doctor visits.",
    name: "Amit Kumar",
    location: "Noida",
  },
  {
    quote: "My Root Canal Treatment did not hurt my pocket so much, Thank you Tron!",
    name: "Sneha Singh",
    location: "Delhi",
  },
];

const Testimonials = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    return (
      <Box className="testimonials">
        <Typography variant="h4" className="testimonials__header">
          What Our Customers Say
        </Typography>
        <Typography
          variant="subtitle1"
          className="testimonials__subheader"
          style={{
            marginTop: isMobile ? "20px" : "",
            marginBottom: isMobile ? "20px" : "",
          }}
        >
          Real people. Real savings.
        </Typography>
  
        <Box className="testimonials__grid">
          {testimonials.map((t, i) => (
            <Box className="testimonial-card" key={i}>
              <Typography className="quote">“{t.quote}”</Typography>
              <Box className="author">
                <Typography className="name">{t.name}</Typography>
                <Typography className="location">{t.location}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };
  
  export default Testimonials;
  